/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";

// Images
import team2 from "assets/images/team-2.jpg";

import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Divider from "@mui/material/Divider";

import apiClient from "../../../apiClient";
import DataTable from "examples/Tables/DataTable";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";

const ListingsTableData = ({ onRefresh }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [price, setPrice] = useState("");
  const [statusInput, setStatusInput] = useState("Active");
  const [nameFilter, setNameFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [propertyTypeFilter, setPropertyTypeFilter] = useState("");
  const [priceFilter, setPriceFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [darkMode, setDarkMode] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    onConfirm: null,
  });

  const Property = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      {/* <MDAvatar src={image} name={name} size="sm" /> */}
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Category = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  // Fetch states data
  const fetchStates = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/admin/listings");
      // Sort listings by added date in descending order (most recent first)
      const sortedListings = response.data.sort((a, b) => {
        const dateA = new Date(a.added?.at || a.added_at || a.createdAt || 0);
        const dateB = new Date(b.added?.at || b.added_at || b.createdAt || 0);
        return dateB - dateA;
      });
      setData(sortedListings);
    } catch (error) {
      console.error("Error fetching listings data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStates();
  }, [onRefresh]);

  // Handlers
  const handleActivate = async (id, status) => {
    try {
      setConfirmDialog({
        open: true,
        title:
          "Are you sure you want to " +
          (status === "Active" ? "deactivate" : "activate") +
          " this listing?",
        onConfirm: async () => {
          try {
            await apiClient.put(`/admin/listings/${id}`, { status: status });
            await fetchStates(); // Refresh data while staying on the current page
            // Keep current page after refresh
          } catch (error) {
            console.error("Error updating listings status:", error);
          }
        },
      });
    } catch (error) {
      console.error("Error activating listings:", error);
    }
  };

  const handleNameInputChange = (e) => {
    setName(e.target.value);
  };

  const handleCategoryInputChange = (e) => {
    setCategory(e.target.value);
  };

  const handlePropertyTypeInputChange = (e) => {
    setPropertyType(e.target.value);
  };

  const handlePriceInputChange = (e) => {
    setPrice(e.target.value);
  };

  const handleStatusInputChange = (e) => {
    setStatusInput(e.target.value);
  };

  const handleFilterSubmit = () => {
    setNameFilter(name);
    setCategoryFilter(category);
    setPropertyTypeFilter(propertyType);
    setPriceFilter(price);
    setStatusFilter(statusInput);
  };

  const handleClearFilters = () => {
    setNameFilter("");
    setCategoryFilter("");
    setPropertyTypeFilter("");
    setPriceFilter("");
    setStatusFilter("");
    setName("");
    setCategory("");
    setPropertyType("");
    setPrice("");
  };

  // Filter data
  const filteredRows = data.filter((row) => {
    return (
      (nameFilter === "" || row.name.toLowerCase().includes(nameFilter.toLowerCase())) &&
      (categoryFilter === "" ||
        row.category.toLowerCase().includes(categoryFilter.toLowerCase())) &&
      (propertyTypeFilter === "" ||
        row.property_type.toLowerCase().includes(propertyTypeFilter.toLowerCase())) &&
      (priceFilter === "" || row.price.toLowerCase().includes(priceFilter.toLowerCase())) &&
      (statusFilter === "" || row.status.toLowerCase().includes(statusFilter.toLowerCase()))
    );
  });

  const columns = [
    { Header: "Title", accessor: "name", width: "15%", align: "left" },
    { Header: "Category", accessor: "category", align: "center" },
    { Header: "Property Type", accessor: "property_type", align: "center" },
    { Header: "Price", accessor: "price", align: "center" },
    { Header: "Added Date", accessor: "added_date", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const rows = filteredRows
    .sort((a, b) => new Date(b.added.at) - new Date(a.added.at))
    .map((data) => ({
      name: <Property name={data.name} email="" />,
      category: <Category title={data.category} description={data.description} />,
      property_type: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {data.property_type}
        </MDTypography>
      ),
      price: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {data.price}
        </MDTypography>
      ),
      added_date: new Date(data.added?.at).toLocaleDateString(),
      status: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={data.status}
            color={data.status === "Active" || data.status === "active" ? "success" : "warning"}
            variant="gradient"
            size="sm"
          />
        </MDBox>
      ),
      action: (
        <MDBox display="flex" justifyContent="space-around">
          <IconButton
            onClick={() => handleActivate(data._id, data.status)}
            color={data.status === "Active" || data.status === "active" ? "warning" : "success"}
          >
            <CheckCircleIcon />
          </IconButton>
        </MDBox>
      ),
    }));

  // No data message
  if (loading) return <div>Loading...</div>;
  if (data.length === 0) return <div style={{ justifyContent: "center" }}>No data found.</div>;

  return (
    <div>
      <MDBox
        display="flex"
        gap="1rem"
        mb="1rem"
        justifyContent="left"
        alignItems="left"
        ml="2%"
        width="90%"
      >
        <MDInput
          fullWidth
          label="Name"
          variant="outlined"
          value={name}
          onChange={handleNameInputChange}
        />
        <MDInput
          fullWidth
          label="Category"
          variant="outlined"
          value={category}
          onChange={handleCategoryInputChange}
        />
        <MDInput
          fullWidth
          label="Property Type"
          variant="outlined"
          value={propertyType}
          onChange={handlePropertyTypeInputChange}
        />
        <MDInput
          fullWidth
          label="Price"
          variant="outlined"
          value={price}
          onChange={handlePriceInputChange}
        />
        <Select
          fullWidth
          variant="outlined"
          value={statusInput}
          onChange={handleStatusInputChange}
          displayEmpty
        >
          <MenuItem value="">
            <em>Status</em>
          </MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFilterSubmit}
          sx={{ color: "#fff" }}
        >
          Search
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClearFilters}
          sx={{ color: "#fff" }}
        >
          Clear
        </Button>
      </MDBox>
      <Divider />
      <DataTable
        table={{ columns, rows }}
        isSorted={true}
        entriesPerPage={true}
        showTotalEntries={true}
        noEndBorder
      />
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: darkMode ? "#121212" : "#fff",
            color: darkMode ? "#fff" : "#000",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1300,
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: darkMode ? "#121212" : "#fff",
            color: darkMode ? "#fff" : "#000",
            borderBottom: `1px solid ${darkMode ? "#333" : "#e0e0e0"}`,
          }}
        >
          {confirmDialog.title}
        </DialogTitle>
        <DialogActions
          sx={{
            backgroundColor: darkMode ? "#121212" : "#fff",
            padding: "16px 24px",
          }}
        >
          <Button
            onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
            color="inherit"
            sx={{ color: darkMode ? "#ccc" : "#666" }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              if (confirmDialog.onConfirm) {
                await confirmDialog.onConfirm();
              }
              setConfirmDialog({ ...confirmDialog, open: false });
            }}
            variant="contained"
            color="primary"
            sx={{ color: "#fff", ml: 1 }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
ListingsTableData.propTypes = {
  onRefresh: PropTypes.func.isRequired,
};
export default ListingsTableData;
